/* Component Dependencies */
var changePasswordTemplate = require('templates/changePassword.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var passwordValidation = require('utils/passwordValidation.js');
var Popup = require('libs/popup');
var $ = require('jquery');
var callbackHandler = require('libs/ajaxCallbackHandler');

PubSub.register(AriesComponent.extend({
    type: 'changePassword',
    template: {
        'changePassword': changePasswordTemplate
    },
    bindEvents: function () {
      var _self = this;
      var passwordValidationOptions = {
        isLabelIcon: false,
        passwordModuleSelector: '.js-password-info',
        passwordIconSelector: '.js-field-password + .t-icon',
        confirmPasswordIconSelector: '.js-field-password-confirmation + .t-icon',
        errorClasses: 't-icon-cross',
        successClasses: 't-icon-check',
        validateConfirmPassword: true,
        confirmPasswordFieldSelector: '.js-field-password-confirmation'
      };
      var $submitBtn = _self.$el.find('.submit-btn');
      var $forceHurdleInputVal = _self.$el.find('#without-hurdle-flow').val();

      passwordValidation.initialize(_self.$el, passwordValidationOptions);

      $submitBtn.on('click', function (e) {
        if ( $forceHurdleInputVal !== 'true' ) {
          e.preventDefault();
          _self.submitChangePasswordForm();
        }
      });
    },

    /**
    * This function is used to make ajax call to submit form data
    * and passes response to ajaxCallbackHandler library for further process
    * @returns {boolean} success or failure
    */
    submitChangePasswordForm: function _submitChangePasswordForm(){
      var _self = this;
      // QUERY PARAMETERS
      var dataObj = _self.$el.serialize();
      dataObj += '&sessionToken='+_self.getSessionToken();
      _self.updatePageURI = true;
      // POST CALL TO SUBMIT DATA
      _self.makeAjaxCall({
        method: 'POST',
        url: _self.$el.attr('action'),
        data: dataObj,
        contentType: 'application/x-www-form-urlencoded',
        success: function(data) {
          if ( data.redirect === true ) {
            window.location.href = data.nextStateURI;
          } else {
            callbackHandler.success( data, _self );
          }
        },
        error: function (data) {
          callbackHandler.error( data, _self );
        }
      });
      return true;
    }

}));
